import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle, Clock, Settings, LogIn } from 'lucide-react';
import { LoginForm } from '@/components/auth/LoginForm';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export {};

interface MaintenanceModeProps {
  message?: string;
  isAdmin?: boolean;
  onToggleMaintenance?: () => void;
}

export const MaintenanceMode: React.FC<MaintenanceModeProps> = ({
  message = 'Sistemul este în mentenanță. Vă rugăm să încercați din nou mai târziu.',
  isAdmin = false,
  onToggleMaintenance
}) => {
  const [activeTab, setActiveTab] = useState('maintenance');

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100">
            <AlertTriangle className="h-6 w-6 text-yellow-600" />
          </div>
          <CardTitle className="text-xl font-semibold text-gray-900">
            Mod Mentenanță
          </CardTitle>
          <CardDescription className="text-gray-600">
            Sistemul este temporar indisponibil pentru utilizatorii obișnuiți
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <TabsList className="grid w-full grid-cols-2">
              <TabsTrigger value="maintenance" className="flex items-center space-x-2">
                <AlertTriangle className="h-4 w-4" />
                <span>Status</span>
              </TabsTrigger>
              <TabsTrigger value="login" className="flex items-center space-x-2">
                <LogIn className="h-4 w-4" />
                <span>Autentificare</span>
              </TabsTrigger>
            </TabsList>

            <TabsContent value="maintenance" className="space-y-4 mt-4">
              <div className="text-center space-y-4">
                <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
                  <Clock className="h-4 w-4" />
                  <span>Sistemul nu este disponibil temporar</span>
                </div>

                <p className="text-sm text-gray-700">
                  {message}
                </p>

                {isAdmin && onToggleMaintenance && (
                  <div className="pt-4 border-t">
                    <button
                      onClick={onToggleMaintenance}
                      className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                      <Settings className="h-4 w-4" />
                      <span>Oprire mod mentenanță</span>
                    </button>
                    <p className="text-xs text-gray-500 mt-2">
                      Numai administratorii pot dezactiva modul de mentenanță
                    </p>
                  </div>
                )}

                {!isAdmin && (
                  <div className="space-y-2">
                    <p className="text-xs text-gray-500">
                      Dacă sunteți administrator, utilizați tab-ul "Autentificare" pentru a accesa sistemul
                    </p>
                    <button
                      onClick={() => setActiveTab('login')}
                      className="text-sm text-blue-600 hover:text-blue-800 underline"
                    >
                      Mergi la Autentificare →
                    </button>
                  </div>
                )}
              </div>
            </TabsContent>

            <TabsContent value="login" className="mt-4">
              <div className="space-y-4">
                <div className="text-center text-sm text-gray-600">
                  <p>Administratorii se pot autentifica pentru a accesa sistemul</p>
                </div>
                <LoginForm />
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};